var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c(
            "div",
            { staticClass: "toolbar" },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  placeholder: "分类名称",
                  size: "small",
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.load($event)
                  },
                },
                model: {
                  value: _vm.query.keyword,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.query,
                      "keyword",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "query.keyword",
                },
              }),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-search",
                  },
                  on: { click: _vm.load },
                },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-refresh" },
                  on: { click: _vm.reset },
                },
                [_vm._v("重置")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["distribution:store:category:save"],
                      expression: "['distribution:store:category:save']",
                    },
                  ],
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-plus",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.open()
                    },
                  },
                },
                [_vm._v("新增分类")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.rows,
                "row-key": "id",
                border: "",
                size: "small",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              false
                ? _c("el-table-column", {
                    attrs: { prop: "id", label: "ID", width: "80" },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { prop: "name", label: "分类名称", "min-width": "180" },
              }),
              _c("el-table-column", {
                attrs: { label: "上级分类", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.parentName(scope.row.pid)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "sort", label: "排序", width: "90" },
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: scope.row.status === 1 ? "success" : "info",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(scope.row.status === 1 ? "显示" : "隐藏")
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "160", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["distribution:store:category:update"],
                                expression:
                                  "['distribution:store:category:update']",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.open(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["distribution:store:category:delete"],
                                expression:
                                  "['distribution:store:category:delete']",
                              },
                            ],
                            staticClass: "danger",
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.remove(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.form.id ? "编辑分类" : "新增分类",
            visible: _vm.visible,
            width: "480px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            closed: _vm.clearForm,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "分类名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "40", "show-word-limit": "" },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "name",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "上级分类" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { clearable: "", placeholder: "一级分类" },
                      model: {
                        value: _vm.form.pid,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "pid", $$v)
                        },
                        expression: "form.pid",
                      },
                    },
                    _vm._l(_vm.parentOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "排序" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, max: 9999 },
                    model: {
                      value: _vm.form.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "sort", $$v)
                      },
                      expression: "form.sort",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "显示" } },
                [
                  _c("el-switch", {
                    attrs: { "active-value": 1, "inactive-value": 0 },
                    model: {
                      value: _vm.form.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "status", $$v)
                      },
                      expression: "form.status",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.saving },
                  on: { click: _vm.submit },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }